import { Fragment } from "react";
import Accordion from "../Accordion/Accordion";
import "./Faq.css";

const Faq = ({ setShowModal }) => {
  return (
    <Fragment>
      <div
        className="container mx-auto h-full relative faq-parent mb-10"
        id="faq"
      >
        <div
          className="content-aside-container text-white relative flex faq__container"
          style={{ marginTop: "70px" }}
        >
          <h1 className="text-2xl md:text-4xl mb-8 title flex-container__title">
            Frequently Asked Questions
          </h1>
        </div>
        <div className="accordion-container px-5">
          <Accordion
            title="1.	Is there an entrance fee to enter the event?"
            isActivate={true}
          >
            Day 1 of the event is free of charge; you’d simply need to register to enter{" "}
            {/* eslint-disable-next-line */}
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                setShowModal(true)
              }}
              className="ticket-here"
            >
              here
            </a>
            . However, a ticket is required for Day 2, which you can purchase{" "}
            <a
              href="https://tmc.quintagen.com/"
              target="_blank"
              rel="noreferrer"
              className="ticket-here"
            >
              here
            </a>.
          </Accordion>
          <Accordion title="2.	Who is welcome to attend this event?">
            This event is open to the public, so feel free to bring your friends and family to enjoy the music and activities together!
          </Accordion>
          <Accordion title="3.	Where will the event take place?">
            The event will be held at Taylor's University Lakeside Campus. For directions, please click on this{" "}
            <a
              href="https://www.google.com/maps/dir//Taylor's+Lakeside,+47100+Subang+Jaya,+Selangor/@3.0630348,101.6167465,17z/data=!4m17!1m7!3m6!1s0x31cc4b62bbbe4a03:0x7b695a7770888b58!2sTaylor's+Lakeside!8m2!3d3.0630737!4d101.6166661!16s%2Fg%2F11b6hyfptb!4m8!1m0!1m5!1m1!1s0x31cc4b62bbbe4a03:0x7b695a7770888b58!2m2!1d101.6166661!2d3.0630737!3e3?entry=ttu"
              target="_blank"
              rel="noreferrer"
              className="ticket-here"
            >
              link
            </a>.
          </Accordion>
          <Accordion title="4.	Are there any age restrictions for the event?">
            The event is open to all ages. Families with children are encouraged to join in on the fun!
          </Accordion>
          <Accordion title="5.	Will there be food and beverages available at the event? ">
            Yes, there will be various food and beverage vendors onsite to satisfy your cravings during the event.
          </Accordion>
          <Accordion title="6.	Can I bring my own food and drinks? ">
            Outside food and drinks are not allowed within the event premises. But don't worry, there will be plenty of delicious options available.
          </Accordion>
          <Accordion title="7.	Can I refund or transfer my tickets if I can't attend? ">
            Unfortunately, tickets are non-refundable, but they are transferable. Please contact our ticketing support for assistance.
          </Accordion>
          <Accordion title="8.	Is there a schedule of performances and activities available? ">
            Yes, a detailed schedule of performances and activities will be provided closer to the event date. Keep an eye on our website for updates.
          </Accordion>
          <Accordion title="9.	Is the event accessible for individuals with disabilities? ">
            Yes, we have made arrangements to ensure that the event is accessible and inclusive for all attendees.
          </Accordion>
          <Accordion title="10.	How can I stay updated with event information? ">
            Stay connected with us on our social media channels and website to receive the latest news and announcements about the event.
          </Accordion>
        </div>
      </div>
    </Fragment>
  );
};

export default Faq;
